module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAPNJREFUSInFlcERgjAQRXcZOrAFh7MdGE7ahXYCdGIZ3oASvDpjCbbg92CCJGEHDMn4TmFn5/9dNixEieElSQCUPlZE1Otzx8zdKncALWxe8KlDhNWE0BzLjADUAeLLTFaKG9RYkx0D/PQuBZh50M3G1ccQ11rtYDYKWtVfrne6PZ6zYqdDQbvtxoubLjItroLLFTCauX72DM7HIopRNp8SBOjz1Q8d7N2MlTNg0islVQc28HdODFTSDsymzaUEaQbSvXdozCFJB8xcW4HIM7DEY3fQuNWLMwignPqFhhiA7DXfMXMpJRuDXkoQaIi+V/GvvAGfMMHJrMi8XgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImg/2_active.png
// module id = W6Jp
// module chunks = 171